module.exports = __webpack_public_path__ + "assets/img/mo-guest-page-layer-11-0864d6e6.png";